import React, {FC, useState} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import styles from './ShortcutText.css';

interface ShortcutTextProps {
	className?: string;
	length: number;
	children: string;
}

export const ShortcutText: FC<ShortcutTextProps> = props => {
	const {className, length, children} = props;
	const t = useLocalizer();

	const [isExpanded, setIsExpanded] = useState(false);

	const text = isExpanded ? children : children.substr(0, length);

	const handleExpand = () => {
		setIsExpanded(true);
	};

	return (
		<span className={className}>
			{text}
			{!isExpanded && (
				<>
					...&nbsp;
					<button className={styles.expandButton} type='button' onClick={handleExpand}>
						{t('expand')}
					</button>
				</>
			)}
		</span>
	);
};

ShortcutText.displayName = 'ShortcutText';
